import Renderable from 'Component/Renderable';
import LuckyWheel from 'Prefabs/LuckyWheel/LuckyWheel';
import { Alpha } from 'System/Animation/Clip';
import {
    PlayAnimation,
} from '../../System/Animation/AnimationHelper';
import WorldSystem from '../../System/World/WorldSystem';
import ITask from './ITask';
import { delay } from './TaskQueue';

export default class ShowWheelTask implements ITask<WorldSystem> {
   private readonly luckyWheel: LuckyWheel;

    constructor(luckyWheel: LuckyWheel) {
        this.luckyWheel = luckyWheel;
    }

    public *execute(system: WorldSystem): IterableIterator<any> {
        this.luckyWheel.getComponent(Renderable).alpha = 0;
        this.luckyWheel.getComponent(Renderable).visible = true;

        yield* delay(600);

        yield* PlayAnimation(new Alpha(this.luckyWheel, {
            startAlpha: 0,
            endAlpha: 1,
            duration: 500,
        }));

        return;
    }
}
